<template>
  <a-modal
    v-model:visible="visible"
    title="确认退出登录"
    :confirm-loading="loading"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <div class="logout-content">
      <a-space direction="vertical" size="large" fill>
        <div class="warning-icon">
          <icon-exclamation-circle-fill
            style="color: #ff7d00; font-size: 48px"
          />
        </div>
        <div class="warning-text">
          <p>您确定要退出登录吗？</p>
          <p class="sub-text">退出后需要重新登录才能访问系统</p>
        </div>
        <div v-if="userStore.userInfo" class="user-info">
          <p
            >当前用户：{{
              userStore.userInfo.name || userStore.userInfo.username
            }}</p
          >
          <p>角色：{{ getRoleText(userStore.userInfo.role) }}</p>
        </div>
      </a-space>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue';
  import { Message } from '@arco-design/web-vue';
  import { useUserStore } from '@/store';
  import useUser from '@/hooks/user';

  interface Props {
    visible: boolean;
  }

  interface Emits {
    (e: 'update:visible', value: boolean): void;
    (e: 'confirm'): void;
    (e: 'cancel'): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const userStore = useUserStore();
  const { logout } = useUser();
  const loading = ref(false);

  const visible = computed({
    get: () => props.visible,
    set: (value) => emit('update:visible', value),
  });

  // 获取角色中文名称
  const getRoleText = (role: string): string => {
    const roleMap: Record<string, string> = {
      Admin: '管理员',
      Supervisor: '主管',
      Consultant: '咨询师',
    };
    return roleMap[role] || role;
  };

  // 确认退出
  const handleConfirm = async () => {
    try {
      loading.value = true;
      await logout();
      emit('confirm');
      Message.success('退出登录成功');
    } catch (error) {
      Message.error('退出登录失败，请重试');
    } finally {
      loading.value = false;
    }
  };

  // 取消退出
  const handleCancel = () => {
    emit('cancel');
  };
</script>

<style scoped lang="less">
  .logout-content {
    text-align: center;
    padding: 20px 0;
  }

  .warning-icon {
    margin-bottom: 16px;
  }

  .warning-text {
    p {
      margin: 8px 0;
      font-size: 16px;

      &.sub-text {
        color: var(--color-text-3);
        font-size: 14px;
      }
    }
  }

  .user-info {
    background-color: var(--type-fill-2);
    padding: 16px;
    border-radius: 6px;
    margin-top: 16px;

    p {
      margin: 4px 0;
      font-size: 14px;
      color: var(--color-text-2);
    }
  }
</style>
